/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import './Business.css'

import { useDispatch, useSelector } from 'react-redux'

import { getPartners } from '../../../actions/partners.action'

import { Link } from 'react-router-dom'
import i18next from 'i18next'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import Preloader from '../../Preloader'
import { API_URI } from '../../../axios'
import PageHeader from '../../page-header/PageHeader'
import { ChevronRight } from '@mui/icons-material'


const Business = () => {

    const dispatch = useDispatch()
    const language = i18next.language
    const {t} = useTranslation()

    useEffect(() => {
        dispatch(getPartners(language))
    }, [language])

    const partners_s = useSelector(state => state.partners)

    const { partners } = partners_s
    const { results } = partners

    // const handle_delete = (e) => {
    //     if (e.length > 100) {
    //         return e.substring(0, 50) + "..."
    //     } else {
    //         return e.substring(0, 50)
    //     }
    // }

    // const handle_delete_title = (e) => {
    //     if (e.length > 10) {
    //         return e.substring(0, 10) + "..."
    //     } else {
    //         return e.substring(0, 10)
    //     }
    // }

    function removeHtmlTags(input) {
        const htmlTagsRegex = /<[^>]*>/g;
        const cleanText = input.replace(htmlTagsRegex, '');
        return cleanText;
    }

    return (
        <>
            <Helmet>
                <title>{`${t("business")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            {
                results ?
                    <div className='Business services-page'>
                        <PageHeader
                            title={t("business")}
                            breadCrumbItems={[
                                { label: t("home"), path: '/' },
                                { label: t("business"), path: '#' }
                            ]}
                        />
                        <div className="container py-12">
                            {/* <div className="section-title text-center">
                                <h2 className="section-title__title"><Translate title="business" /></h2>
                            </div> */}
                            <div className="row">
                                {
                                    results.map((item, index) => {
                                            return (
                                                <div key={item.id} className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                                    <div className="services-one__single">
                                                        <div className="services-one__img">
                                                            <img src={`${API_URI}${item.image}`} alt="" />
                                                        </div>
                                                        <div className="services-one__content">
                                                            <div className="services-one__title-box">
                                                                <h4 className="services-one__title"><Link to={`/business/${item.id}`} style={{ textDecoration: 'none' }}>{item.title}</Link>
                                                                </h4>
                                                            </div>
                                                            <div className="services-one__text text-2xl" dangerouslySetInnerHTML={{ __html: removeHtmlTags(item.description) }} ></div>
                                                            <div className="services-one__arrow">
                                                                <Link to={`/business/${item.id}`} style={{ textDecoration: 'none' }}><ChevronRight /></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    )
                                }
                            </div>
                        </div>
                    </div> : <Preloader/>
            }
        </>
    )
}

export default Business